{
  "age_over_time": "Average age over time",
  "all_balances": "All balances",
  "average_turnover": "Average turnover",
  "by_departments": "by departments",
  "by_divisions": "by divisions",
  "by_job_profiles": "by job profiles",
  "by_job_roles": "by job roles",
  "by_leave_types": "by leave types",
  "by_locations": "by locations",
  "by_termination_reasons": "by termination reasons",
  "dimension_age_group": "Age group",
  "ending_balance": "Ending balance",
  "gross": "Gross",
  "growth_over_time": "Growth over time",
  "headcount_for_period": "Headcount for period",
  "headcount_over_time": "Headcount over time",
  "headcount_report_description": "Track current employee numbers and department distribution",
  "headcount_report_growth_chart_tooltip": "Shows how quickly the organization grew or shrank compared with the previous interval. Positive values mean the team expanded, while negative values indicate that exits outpaced new hires.",
  "headcount_report_headcount_chart_tooltip": "Shows how the number of employees changed across the selected period. Each point reflects the headcount at the end of its interval, so it helps you spot overall team size trends.",
  "headcount_report_joiners_leavers_chart_tooltip": "Compares employees who joined with employees who left during each interval. This makes it easier to see whether hiring is keeping pace with departures over time.",
  "headcount_report_manager_ratio_chart_tooltip": "Shows the balance between managers and employees over time. Managers are counted as employees who have at least one direct report, so the trend helps reveal changes in management coverage. A manager with direct reports in multiple departments is counted in each bucket.",
  "headcount_report_managers_chart_tooltip": "Shows how many employees were acting as managers in each interval. A manager is counted when at least one employee reports to them, which helps track changes in the leadership layer. A manager with direct reports in multiple departments is counted in each bucket.",
  "headcount_report_people_future": "are\nexpected to be\non your team by",
  "headcount_report_people_now": "are\non your team now",
  "headcount_report_people_were": "were\non your team on",
  "headcount_report_title": "Headcount",
  "headcount_report_turnover_chart_tooltip": "Shows the share of employees who left during each interval. Use it to notice periods with higher replacement pressure and investigate where exits may be concentrated.",
  "include_all_active_description": "Include archived and inactive jobs that had stage changes during the selected period.",
  "include_all_active_title": "Show inactive jobs with stage changes",
  "include_inactive_jobs_description": "Include all active jobs, even if there was no stage changes during the selected period",
  "include_inactive_jobs_title": "Show jobs without stage changes",
  "joiners": "Joiners",
  "joiners_and_leavers": "Joiners and Leavers",
  "last_salary_updated": "Last salary updated",
  "last_updated": "Last updated",
  "leavers": "Leavers",
  "lifetime_growth": "Lifetime growth",
  "manager_ratio_for_period": "Managers per employee for period",
  "manager_ratio_over_time": "Managers per employee over time",
  "managers_for_period": "Managers for period",
  "managers_over_time": "Managers over time",
  "metric_age": "Average age",
  "metric_age_description": "Average employee age for the selected date range and filters",
  "metric_attrition": "Attrition",
  "metric_attrition_description": "Voluntary leavers as a share of average headcount for the selected period",
  "metric_average_salary": "Average salary",
  "metric_growth": "Growth",
  "metric_headcount": "Headcount",
  "metric_joiners": "Joiners",
  "metric_leavers": "Leavers",
  "metric_manager_ratio": "Manager to employee",
  "metric_managers": "Managers",
  "metric_median_salary": "Median salary",
  "metric_retention": "Retention",
  "metric_retention_description": "The share of employees who stayed with the company from the start to the end of the selected period",
  "metric_tenure": "Average tenure",
  "metric_tenure_chart_description": "Average overall time employees have worked at the company, shown in months",
  "metric_tenure_description": "Average overall time employees have worked at the company, shown in years",
  "metric_total_bonus": "Total bonus",
  "metric_total_payroll": "Total payroll",
  "metric_total_cost": "Total cost of employment",
  "metric_employer_contributions": "Employer contributions",
  "metric_turnover": "Turnover",
  "metric_turnover_description": "All voluntary and involuntary leavers as a share of average headcount for the selected period",
  "my_reports": "My reports",
  "net": "Net",
  "over_time": "over time",
  "people_analytics_aggregation_avg": "Average",
  "people_analytics_aggregation_count": "Count",
  "people_analytics_aggregation_count_distinct": "Unique",
  "people_analytics_aggregation_max": "Max",
  "people_analytics_aggregation_median": "Median",
  "people_analytics_aggregation_min": "Min",
  "people_analytics_aggregation_sum": "Sum",
  "people_analytics_aggregation_values": "Values",
  "people_analytics_chart_needs_group": "Pick a grouping to build a chart",
  "people_analytics_chart_needs_series": "Pick at least one numeric column for the chart",
  "people_analytics_chart_unavailable_employee": "Not available when grouped by employee",
  "people_analytics_employee_report": "Employees report",
  "people_analytics_visualisation_bar": "Bar chart",
  "people_analytics_visualisation_line": "Line chart",
  "people_analytics_date_grain_day": "By day",
  "people_analytics_date_grain_month": "By month",
  "people_analytics_date_grain_none": "Exact dates",
  "people_analytics_date_grain_quarter": "By quarter",
  "people_analytics_date_grain_week": "By week",
  "people_analytics_date_grain_year": "By year",
  "people_analytics_group_by_employee": "Employee",
  "people_analytics_group_by_none": "No grouping",
  "people_analytics_group_by_placeholder": "Choose field...",
  "people_analytics_group_people_by": "Group people by",
  "people_analytics_group_empty": "Not set",
  "people_analytics_period": "Period",
  "people_analytics_scope_current": "As of today",
  "people_analytics_scope_as_of": "As of a date",
  "people_analytics_scope_as_of_desc": "Metric values on the selected date",
  "people_analytics_scope_period": "Events in period",
  "people_analytics_scope_period_desc": "Metric updates in the selected period",
  "people_analytics_scope_choose_period": "Choose period",
  "people_analytics_scope_choose_date": "Choose date",
  "people_analytics_choose_field": "Choose field",
  "people_analytics_empty_group_title": "Choose how to group people",
  "people_analytics_empty_group_description": "Start with a field such as department, location, or employment type.",
  "people_analytics_add_metric": "Add metric",
  "people_analytics_filter": "Filter",
  "people_analytics_filter_by": "Filter by {name}",
  "people_analytics_filter_search": "Search field",
  "people_analytics_configure": "Configure",
  "people_analytics_save_blocked_values": "The “Values” aggregation can only be saved in a table. Switch the visualisation to a table, or choose another aggregation for those columns.",
  "people_analytics_show_metrics": "Show metrics",
  "people_analytics_sort": "Sort",
  "people_analytics_sort_asc": "Ascending",
  "people_analytics_sort_desc": "Descending",
  "people_analytics_sort_none": "No sorting",
  "people_analytics_new_report": "New report",
  "people_analytics_description": "Explore and group employee data across any dimension",
  "people_analytics_report_title": "{group} report",
  "people_analytics_title": "People analytics",
  "people_analytics_visualisation": "Visualisation",
  "people_analytics_total_employees": "Total employees",
  "people_analytics_row_total": "Total",
  "people_analytics_warning_history_access_denied": "No access to history — current row shown",
  "people_analytics_warning_metric_requires_period": "This metric needs the “period” time scope",
  "people_analytics_cache_built_at": "Data as of {date}",
  "people_analytics_cache_live": "Data is calculated live",
  "people_analytics_cache_rebuild": "Refresh now",
  "people_analytics_save_as": "Save as",
  "people_analytics_save_as_new": "Save as new...",
  "people_analytics_save_widget": "Save as widget",
  "people_analytics_widget_saved": "Widget saved",
  "people_analytics_widget_title": "Widget title",
  "people_analytics_widget_updated": "Report updated",
  "people_analytics_rename": "Rename",
  "people_analytics_rename_report": "Rename report",
  "people_analytics_delete_report": "Delete report",
  "people_analytics_delete_confirm": "Delete report “{title}”? This can’t be undone.",
  "people_analytics_warning_no_history": "No history — current value shown",
  "people_analytics_warning_missing_fx_rate": "Some payments are not included: no exchange rate",
  "people_analytics_warning_missing_currency": "Some amounts are not included: no currency specified",
  "period_growth": "Period growth",
  "permissions_headcount_report_description": "View headcount report",
  "permissions_people_analytics_report_description": "View People analytics report",
  "permissions_retention_report_description": "View retention report",
  "permissions_salary_report_description": "View salary report",
  "permissions_time_off_balance_report": "View time off balances for team",
  "permissions_time_off_history_report": "View time off history for team",
  "retention_over_time": "Retention over time",
  "retention_report_description": "Track employee retention, turnover, attrition, and tenure",
  "retention_report_title": "Retention",
  "salary_allocation_by_days": "Transfers split by days",
  "salary_allocation_period_end": "Transfers at period end",
  "salary_average": "Average {salary_type}",
  "salary_average_changes_gross": "Average gross salary changes",
  "salary_average_changes_net": "Average net salary changes",
  "salary_average_gross": "Average gross salary",
  "salary_average_net": "Average net salary",
  "salary_by_departments": "By departments",
  "salary_by_divisions": "By divisions",
  "salary_by_job_profiles": "By job profiles",
  "salary_by_job_roles": "By job roles",
  "salary_by_locations": "By locations",
  "salary_changes": "{salary_type} changes",
  "salary_changes_gross": "Gross salary changes",
  "salary_changes_net": "Net salary changes",
  "salary_gross": "Gross salary",
  "salary_median": "Median {salary_type}",
  "salary_median_gross": "Median gross salary",
  "salary_median_net": "Median net salary",
  "salary_net": "Net salary",
  "salary_report_description": "Track and analyze changes in employee salaries",
  "salary_report_title": "Salary",
  "split_by": "Split by",
  "tenure_over_time": "Average tenure over time",
  "time_off_balance_report_description": "Track available vacation days, sick leave, and other time-off for your team",
  "time_off_history_report_description": "Track time off requests and approvals for your team",
  "time_off_history_report_title": "Time off history",
  "tooltip_current_period": "At the end of period",
  "tooltip_previous_period": "At the beginning of period",
  "total_gross_pay": "Total gross payouts for the period",
  "total_headcount": "Total headcount",
  "total_net_pay": "Total net payouts for the period",
  "~": "~"
}
